import React, { Component } from 'react'
import green from 'material-ui/colors/green'
import Messages from '../constants/messages'
import PropTypes from 'prop-types'
import { validateRegistrationPassword } from '../utils/validationRules'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  password: PropTypes.string
}

const styles = theme => ({
  confirmCheck: {
    color: green[500],
    '&:after': {
      content: "' \u2714'"
    }
  },
  confirmNoCheck: {
    color: green[500]
  },
})

export class PasswordRequirements extends Component {
  render() {
    const { classes, password, email, firstName, lastName } = this.props
    return (
      <ul data-test-id="passwordReqs" className={classes.passwordToolTip}>
        <li data-test-id="username-check" className={validateRegistrationPassword('usernameCheck', password, email) ? classes.confirmCheck : null}>{Messages['tooltips']['PASSWORD_POLICY4']}</li>
        <li data-test-id="length-check" className={validateRegistrationPassword('lengthCheck', password) ? classes.confirmCheck : null}>{Messages['tooltips']['PASSWORD_POLICY1']}</li>
        <li data-test-id="firstname-check" className={validateRegistrationPassword('firstName', password, email, firstName, lastName) ? classes.confirmCheck : null}>{Messages['tooltips']['PASSWORD_POLICY2']}</li>
        <li data-test-id="lastname-check" className={validateRegistrationPassword('lastName', password, email, firstName, lastName) ? classes.confirmCheck : null}>{Messages['tooltips']['PASSWORD_POLICY3']}</li>
      </ul>
    )
  }
}

PasswordRequirements.propTypes = PROP_TYPES

export default withStyles(styles)(PasswordRequirements)